import * as Yup from 'yup';
import { currencyValidationSchema } from '../elements';

export const subscribeFormValidationSchema = () =>
    Yup.object({
        currency: currencyValidationSchema()
    });